import { getController } from '@/services/service'

const url = 'handoverimages'

export const handoverImageService = {
	...getController<
		Api.HandoverImage,
		Api.HandoverImagePostInput,
		Api.HandoverImageUpdateInput
	>(url),
}
